import React, { Component } from 'react';
import { Breadcrumb, Tabs, Button, Form, Input, Radio, DatePicker, message, Select, Modal } from 'antd';
import './index.less';
import { API } from '@/http/api';
import http from '@/http';
import moment from "moment";
import Table from "CMPT/common/Table";
const { RangePicker } = DatePicker;
const BreadcrumbItem = Breadcrumb.Item;
const { TabPane } = Tabs;
const { Search, TextArea } = Input;

const Option = Select.Option
const RadioGroup = Radio.Group
class UserOrder extends Component {

    state = {
        loading:false,
        searchValue: '',
        companyName: '',
        columns: [
            {
                title: "姓名",
                key: "accountName",
                align: "center",
                dataIndex: "accountName",
            },
            {
                title: "手机号码",
                key: "accountPhone",
                align: "center",
                dataIndex: "accountPhone",
            },
            {
                title: "企业名称",
                key: "organizationName",
                align: "center",
                dataIndex: "organizationName",
                render: (text) => {
                    return (
                        <span>{text ? text : "-"}</span>
                    );
                },
            },
            {
                title: "查询时间",
                key: "createDate",
                align: "center",
                dataIndex: "createDate",
                render: (text, record) => {
                    return (
                        <span>{text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"}</span>
                    );
                },
            },
            {
                title: "查询车辆",
                key: "plate",
                align: "center",
                dataIndex: "plate",
            },
            {
                title: "查询类型",
                key: "trackQueryTypeName",
                align: "center",
                dataIndex: "trackQueryTypeName",
            },
            {
                title: "使用次数",
                key: "usedNumber",
                align: "center",
                dataIndex: "usedNumber",
            },
        ],
        params: {
            pageSize: 10,
            pageNo: 1,
        },
        addRecordList: [],
    }

    componentDidMount() {
        this.auditList()
    }

    auditList = () => {
        let { params } = this.state;
        this.setState({
            loading: true,
        })
        const config = {
            api: API.usedRecords,
            data: params
        };
        http(config).then(res => {
            if (res.code == 200) {
                res.result.total = Number(res.result.total)
                this.setState({
                    addRecordList: res.result,
                    loading: false,
                })
            }
        })
    }

    rangeChange = (value, date) => {
        let params = this.state.params;
        params.startDate = date[0];
        params.endDate = date[1];
        this.setState({
            params,
            startDate: value[0],
            endDate: value[1]
        }, () => {
            this.auditList();
        })
    }

    resetSearch = () => {
        let { params } = this.state;
        params.keyword = '';
        params.startDate = '';
        params.endDate = '';
        params.tenantCode = undefined;
        params.queryStatus = undefined;
        params.trackQueryType = undefined;

        this.setState({
            params,
            startDate: undefined,
            endDate: undefined,
            searchValue: '',
            companyName: '',
        }, () => {
            this.auditList()
        })
    }

    //分页
    onChangePage = (pageNo, pageSize, sort) => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    pageNo: pageNo,
                    pageSize: pageSize,
                },
            },
            () => {
                this.auditList();
            }
        );
    };


    render() {
        const {addRecordList, columns,  startDate, endDate,} = this.state;
        return (

            <div className="enterprise-auth-con-1">
                <div className='tab_box'>

                    <div className='table_box' style={{ paddingTop: '24px' }}>
                        <div className="goods_fliter">
                            <RangePicker value={[startDate, endDate]} onChange={this.rangeChange} style={{ marginRight: '12px' }} />

                            <span className="goods_reset" onClick={this.resetSearch}>重置</span>
                        </div>
                        <Table
                            columns={columns}
                            selfProcessData={addRecordList && addRecordList.records}
                            total={addRecordList && addRecordList.total}
                            change={this.onChangePage}
                            current={addRecordList && addRecordList.current}
                        />
                    </div>
                </div>

            </div>

        );
    }
}

const UserTOrder = Form.create({ name: "UserOrder" })(UserOrder);
export default UserTOrder;